import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Button from '../../../../button';
import Modalheader from '../../../components/header';
import ModalBody from '../../../components/body';
import ModalFooter from '../../../components/footer';
import useModal from '../../../useModal';
import UseContext from '../../../../../hooks/useContext';
import ApiDatabase from 'server';

const ModalMissionResume = () => {
  const { toggle } = useModal();
  const { objID, setModalDataReturn, updateMissionStatusLocal } = UseContext();
  const [isLoading, setIsLoading] = useState(false);
  const [missionData, setMissionData] = useState(null);
  const [newDateStart, setNewDateStart] = useState('');
  useEffect(() => {
    if (objID) {
      ApiDatabase.getMissionDetailsById(
        { idMission: objID },
        (data) => setMissionData(data),
        (err) => console.error(err),
        { skipCache: true }
      );
    }
  }, [objID]);

  const isPast = missionData?.duration?.datestart
    && new Date(missionData.duration.datestart) < new Date();

  const today = new Date().toISOString().slice(0, 10);

  const canSubmit = missionData && (!isPast || newDateStart);

  const handleSubmit = () => {
    if (!objID || !canSubmit) return;
    setIsLoading(true);

    const payload = { idMission: objID, newStatus: 'online' };
    if (isPast && newDateStart) {
      payload.newDateStart = newDateStart;
    }

    ApiDatabase.updateMissionStatus(
      payload,
      () => {
        updateMissionStatusLocal(objID, { status: 'online', reason: null });
        setModalDataReturn('mission_status_updated');
        toast.success('La mission est de nouveau en ligne');
        setIsLoading(false);
        toggle();
      },
      (err) => {
        toast.error('Erreur lors de la mise en ligne : ' + err);
        setIsLoading(false);
      }
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Mettre la mission en ligne
      </Modalheader>
      <ModalBody>
        {!missionData ? (
          <div className="flex flex-col gap-3">
            <div className="h-4 skeleton-bar w-full" />
            <div className="h-4 skeleton-bar w-3/4" />
          </div>
        ) : (
          <div className="flex flex-col gap-4">
            <p>
              Êtes-vous sûr de vouloir mettre en ligne la mission{' '}
              <span className="font-black">
                {missionData.title} n°{missionData.id_mission}
              </span>
              .{isPast
                ? ' La date de début est passée, veuillez choisir une nouvelle date de début.'
                : ' La mission sera de nouveau visible par les candidats.'}
            </p>
            {isPast && (
              <input
                type="date"
                min={today}
                value={newDateStart}
                onChange={(e) => setNewDateStart(e.target.value)}
                className="w-full h-10 px-3 border border-gray-300 rounded-lg text-sm"
              />
            )}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button size="LG" color="SECONDARY" onClick={toggle}>
          Annuler
        </Button>
        {isLoading ? (
          <Button size="LG" color="DISABLED">
            Confirmation ...
          </Button>
        ) : (
          <Button size="LG" color={canSubmit ? 'PRIMARY' : 'DISABLED'} onClick={handleSubmit} disabled={!canSubmit}>
            Confirmer
          </Button>
        )}
      </ModalFooter>
    </>
  );
};

export default ModalMissionResume;
